import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { ReportType } from '../models/reporttype';

@Injectable()
export class ReportTypeService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }


  public getAll(): Promise<ReportType[]> {
    return new Promise((resolve, reject) => {
      this.http.get<ReportType[]>(environment.apiUrl + 'reportType/getall').subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public get(id: Number): Promise<ReportType> {
    return new Promise((resolve, reject) => {
      this.http.get<ReportType>(environment.apiUrl + 'reportType/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public save(category: ReportType): Promise<ReportType> {
    return new Promise((resolve, reject) => {
      if (category.is_edit) {
        this.http.put<ReportType>(environment.apiUrl + 'reportType/put', category).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated category');
        }, error => {
          //console.log(error);
          reject();
        });
      } else {
        this.http.post<ReportType>(environment.apiUrl + 'reportType/post', category).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added category');
        }, error => {
          //console.log(error);
          reject();
        });
      }
    });
  }

}
